import { render, staticRenderFns } from "./JobListingJobDetail.vue?vue&type=template&id=984059b8&scoped=true&"
import script from "../../../services/applicant/job_listing/job-listing-job-detail.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/job_listing/job-listing-job-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=984059b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984059b8",
  null
  
)

export default component.exports